// #87 ResponseAvatar: a person's initials whose ring is their response (Accepted --green-text · Declined --red-text ·
// nonresponse grey --text-3; DC-40 text twins). The ring is never the only carrier: the accessible name is
// "name, status", and the same words are the tooltip on hover and focus, so the avatar is a tab stop (or a link with
// `href`).

import { initialsOf } from "../core";
import { ACKNOWLEDGMENT_STATUS, RESPONSE_STATUS } from "../labels";
import { cx } from "../lib/cx";
import { useHs, type Hs } from "../lib/hs";
import { Tooltip } from "../lib/Tooltip";

export type ResponseKind = "accepted" | "declined" | "nonresponse";

export const RESPONSE_WORDS: Readonly<Record<ResponseKind, string>> = {
  accepted: ACKNOWLEDGMENT_STATUS.accepted,
  declined: ACKNOWLEDGMENT_STATUS.declined,
  nonresponse: RESPONSE_STATUS.nonresponse,
};

export interface ResponseAvatarProps {
  name: string;
  response: ResponseKind;
  size?: 24 | 32 | undefined;
  href?: string | undefined;
  hs?: Hs | undefined;
  className?: string | undefined;
}

export function ResponseAvatar({ name, response, size = 32, href, hs, className }: ResponseAvatarProps) {
  const hot = useHs(hs);
  const named = `${name}, ${RESPONSE_WORDS[response]}`;
  const classes = cx("mc-av", "mc-resp", `mc-resp-${response}`, size === 24 && "mc-s24", className);
  const initials = <span aria-hidden="true">{initialsOf(name)}</span>;
  const face = href !== undefined
    ? <a href={href} className={classes} aria-label={named} {...hot}>{initials}</a>
    : <span className={classes} role="img" aria-label={named} tabIndex={0} {...hot}>{initials}</span>;
  return <Tooltip label={named} mode="mirror">{face}</Tooltip>;
}
